import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import styled from '@emotion/styled'

import GridItemText from 'components/common/GridItem/GridItemText'
import { ArrowRight } from 'components/common/SVGElements'
import { setNavbarClicked } from 'store/pageLoad/pageLoadSlice'
import { GtmAgent } from 'utils/hooks/analytics'

const GridWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 24px;
`

const Link = styled(Box)`
  ${({ theme }) => `
    font-weight: bold;
    background: ${theme.palette.grey.third};
    padding: 12px 12px 12px 20px;
    cursor: pointer;
    border-radius: 6px;
    &:hover {
      background: ${theme.palette.primary.bgPlus1};
    }
  `}
`

const NavGridText = ({
  content,
  menuDataForGa,
  hasSubMenu,
  onLinkClick,
  onCatalogOrSubMenuClick,
  onServiceClassificationClick,
}) => {
  const dispatch = useDispatch()

  const [showSubcatalog, setShowSubcatalog] = useState([])

  useEffect(() => {
    const list = content?.subcatalogs
    setShowSubcatalog(
      list
        ?.sort((a, b) => {
          if (b.sort !== a.sort) {
            return b.sort - a.sort
          }
          return new Date(b.createdAt) - new Date(a.createdAt)
        })
        .filter((listItem) => listItem?.items.length > 0)
    )
  }, [content.name, hasSubMenu])

  return (
    <Box>
      {content?.link ? (
        <Box mb={8} display="flex">
          <Link
            display="inline-flex"
            alignItems="center"
            onClick={() => {
              GtmAgent.directSendToGTM({
                event: 'living_action',
                living_event_name: 'headermenu_click',
                living_click_name: content?.linkDisplayName
                  ? content.linkDisplayName
                  : `前往${content?.name}`,
                living_click_location: 'web_主選單細項',
                living_category1_name: menuDataForGa?.name,
                ...(menuDataForGa?._id && {
                  living_category1_id: menuDataForGa._id,
                }),
                ...(content?.name &&
                  hasSubMenu && { living_category2_name: content.name }),
                ...(content?._id &&
                  hasSubMenu && { living_category2_id: content._id }),
              })

              dispatch(setNavbarClicked(true))
              onCatalogOrSubMenuClick(content)
            }}
          >
            <Box display="inline-block" color={'primary.main'} marginRight={1}>
              {content.linkDisplayName
                ? content.linkDisplayName
                : `前往${content.name}`}
            </Box>
            <ArrowRight color="text.secondary" />
          </Link>
        </Box>
      ) : (
        ''
      )}
      {hasSubMenu && (
        <Typography variant="labelLarge" color="text.secondary" sx={{ pb: 4 }}>
          {content.name}
        </Typography>
      )}
      {showSubcatalog.map((listItem, index) => {
        return (
          <Box key={index} mt={index === 0 ? 0 : 6}>
            {showSubcatalog?.length > 1 || hasSubMenu ? (
              <Typography
                variant="labelLarge"
                color={hasSubMenu ? 'text.disabled' : 'text.secondary'}
              >
                {listItem.name}
              </Typography>
            ) : (
              ''
            )}
            <Box mt={2.5}>
              <GridWrapper>
                {listItem?.items?.map((item, index) => {
                  return (
                    <GridItemText
                      key={index}
                      item={item}
                      menuDataForGa={menuDataForGa}
                      subMenuDataForGa={{
                        name: content.name,
                        _id: content?._id,
                      }}
                      subCatalogDataForGa={{
                        name: listItem.name,
                        _id: listItem?._id,
                      }}
                      handleClose={onLinkClick}
                      onServiceClassificationClick={
                        onServiceClassificationClick
                      }
                      hasSubMenu={hasSubMenu}
                    ></GridItemText>
                  )
                })}
              </GridWrapper>
            </Box>
          </Box>
        )
      })}
    </Box>
  )
}

export default NavGridText
